import { FC } from 'react';
import { useHref, useLinkClickHandler } from 'react-router-dom';

import { Button, ButtonProps } from 'antd';

interface IButtonStyleLinkProps extends Partial<ButtonProps> {
	to: string;
}

export const ButtonStyleLink: FC<IButtonStyleLinkProps> = ({ children, to, onClick, ...props }) => {
	const href = useHref(to);
	const handleClick = useLinkClickHandler(to);

	return (
		<Button
			href={href}
			onClick={(event) => {
				onClick?.(event);
				if (!event.defaultPrevented) {
					handleClick(event as React.MouseEvent<HTMLAnchorElement, MouseEvent>);
				}
			}}
			{...props}>
			{children}
		</Button>
	);
};
